module.exports = __webpack_public_path__ + "img/entrance-disabled.f407b87b.svg";